// =============================================================================
// Child theme entry — client-specific JS goes here.
// The parent theme (ai-zippy) handles core behaviors; use this file only for
// client overrides or new features that don't belong in core.
// =============================================================================

// Example:
// import "./modules/client-hero.js";

console.log("[ai-zippy-child] loaded");
